export default __webpack_public_path__ + "static/media/nft18.308f396a.png";